import type { ExternalTableSchema } from '@packages/table-builder';

export const systemUserApprovalTable: ExternalTableSchema = {
  metadata: {
    title: 'System User Approval',
    entity: 'system-user-approval',
    description: 'Review and approve pending system user requests.',
  },
  dataSource: {
    endpoint: '/api/customer/api/app/customer-user-approval/customer-user-list',
    method: 'GET',
    rowIdField: 'customerUserId',
    responseMapping: { items: 'items', totalCount: 'totalCount' },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      Statuses: 'filters.approvalStatusId',
      IsEnabled: 'filters.userStatus',
    },
    filters: [
      {
        name: 'approvalStatusId',
        semanticId: 'systemUserApprovalFilterApprovalStatus',
        placeholder: 'Approval Status',
        type: 'asyncSelect',
        multiple: true,
        dataSource: {
          url: '/api/customer/api/app/customer-user-approval/customer-user-status-list',
          labelField: 'status',
          valueField: 'statusId',
        },
      },
      {
        name: 'userStatus',
        semanticId: 'systemUserApprovalFilterUserStatus',
        placeholder: 'User Status',
        type: 'select',
        multiple: true,
        options: [
          { label: 'Active', value: true },
          { label: 'Deactivated', value: false },
        ],
      },
    ],
  },
  columns: [
    {
      field: 'fullName',
      header: 'Employee Details',
      type: 'couple',
      width: 300,
      sortable: true,
      couple: { titleField: 'fullName', subtitleField: 'email' },
    },
    { field: 'companyName', header: 'Company Name', type: 'text', width: 200, visibility: 'picker' },
    { field: 'customerDepartment', header: 'Department', type: 'text', width: 200, sortable: true },
    { field: 'customerTitle', header: 'Job Title', type: 'text', width: 200, sortable: true },
    { field: 'creationTime', header: 'Created Date', type: 'date', width: 200, visibility: 'picker' },
    {
      field: 'customerRole',
      header: 'System Role',
      type: 'modal',
      width: 200,
      sortable: true,
      modal: { actionId: 'CUSTOMER_ROLE_POPOVER_SYSTEM_USER_APPROVAL' },
    },
    {
      field: 'isEnabled',
      header: 'User Status',
      type: 'badge',
      width: 150,
      sortable: true,
      align: 'center',
      conditionalValues: { true: 'Active', false: 'Deactivated' },
      badge: { statusMap: { true: 'info', false: 'error' } },
    },
    {
      field: 'statusId',
      header: 'Status',
      type: 'badge',
      sortable: true,
      align: 'center',
      conditionalValues: { '1': 'Pending', '2': 'Approved', '3': 'Rejected' },
      badge: { statusMap: { '1': 'info', '2': 'success', '3': 'error' } },
    },
    {
      field: 'isDefaultApprover',
      header: 'Default Approver',
      type: 'badge',
      sortable: true,
      align: 'center',
      visibility: 'picker',
      conditionalValues: { true: 'YES', false: 'NO' },
      badge: { statusMap: { true: 'success', false: 'error' } },
    },
  ],
  actions: {
    row: [
      { id: 'VIEW_SYSTEM_USER_APPROVAL', label: 'View' },
      { id: 'UPDATE_SYSTEM_USER_APPROVAL', label: 'Update' },
      { id: 'APPROVE_SYSTEM_USER_APPROVAL', label: 'Approve' },
      { id: 'REJECT_SYSTEM_USER_APPROVAL', label: 'Reject' },
      { id: 'VIEW_COMMENTS_SYSTEM_USER_APPROVAL', label: 'View Comments' },
    ],
  },
  features: {
    search: { enabled: true, placeholder: 'Search' },
    filters: { enabled: true },
    filterGrid: { columns: 2 },
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
    columnPreferences: { persistenceKey: 'System Users Approval', resizable: true, reorderable: true },
  },
};
